import React from "react";

interface Props {
  step: number;
  title: string;
  desc: string;
}

const Step = (props: Props) => {
  return (
    <div className="step">
      <div className="step">STEP {props.step}</div>
      <div className="title">{props.title}</div>
      <div className="desc">{props.desc}</div>
    </div>
  );
};

export default Step;
